import React from 'react';
import { FileSearch } from 'lucide-react';
import DataSection from '../dataSections/DataSection';

export default function Scraping() {
  return (
    <DataSection
      title="Scraping"
      icon={FileSearch}
      contentType="webscraped"
      executionUrlSuffix="scraping"
      isComplex
    />
  );
}

